import { appendElement } from '../xml-helpers';
import { buildContributors, buildTitles, buildDoiData } from './index';
import type { ContributorInput } from './contributors.builder';

export interface SeriesMetadataInput {
  seriesTitle: string;
  issn: string;
  contributors?: ContributorInput[];
  doi?: string;
  landingPageUrl?: string;
}

/**
 * Appends a `<series_metadata>` element to the parent.
 *
 * XSD element order for series_metadata:
 * contributors, titles, issn, doi_data
 */
export function buildSeriesMetadata(
  parent: Element,
  series: SeriesMetadataInput
): Element {
  const seriesMeta = appendElement(parent, 'series_metadata');

  // 1. contributors (optional)
  if (series.contributors && series.contributors.length > 0) {
    buildContributors(seriesMeta, series.contributors);
  }

  // 2. titles
  buildTitles(seriesMeta, series.seriesTitle);

  // 3. issn (required)
  appendElement(seriesMeta, 'issn', series.issn);

  // 4. doi_data (optional)
  if (series.doi && series.landingPageUrl) {
    buildDoiData(seriesMeta, series.doi, series.landingPageUrl);
  }

  return seriesMeta;
}
